import { defineComponent, createBlock, openBlock, normalizeClass, withCtx, createElementBlock, createCommentVNode, renderSlot, createElementVNode, toDisplayString, Fragment, renderList, createVNode, mergeProps, createTextVNode } from 'vue';
import _sfc_main$3 from './basler-components.es68.js';
/* empty css                       */
import _sfc_main$6 from './basler-components.es70.js';
/* empty css                       */
import _sfc_main$1 from './basler-components.es75.js';
/* empty css                       */
import _sfc_main$4 from './basler-components.es114.js';
/* empty css                        */
import _sfc_main$5 from './basler-components.es133.js';
import _sfc_main$2 from './basler-components.es87.js';
/* empty css                       */

const _hoisted_1 = { class: "product-card__header theme-light" };
const _hoisted_2 = { class: "product-card__headline" };
const _hoisted_3 = { class: "product-card__headline-inner" };
const _hoisted_4 = ["innerHTML"];
const _hoisted_5 = ["innerHTML"];
const _hoisted_6 = { key: 0 };
const _hoisted_7 = ["innerHTML"];
const _hoisted_8 = {
  key: 0,
  class: "product-card__price-container"
};
const _hoisted_9 = {
  key: 0,
  class: "product-card__price-prefix-box"
};
const _hoisted_10 = { class: "product-card__price-prefix" };
const _hoisted_11 = {
  key: 0,
  class: "product-card__price-prefix-attention-text"
};
const _hoisted_12 = { class: "product-card__price-text-box" };
const _hoisted_13 = {
  key: 0,
  class: "product-card__price-text"
};
const _hoisted_14 = {
  key: 1,
  class: "product-card__previous-price-text"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "ProductCard",
  props: {
    product: {},
    badgeText: { default: "" },
    badgeStyle: {},
    showAttributes: { type: Boolean, default: true },
    link: {},
    isLoading: { type: Boolean, default: false },
    loadingLines: { default: 3 },
    attributesLoadingLines: { default: 3 },
    isFullsizeImage: { type: Boolean, default: false },
    cardDataAttributes: {}
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      return openBlock(), createBlock(_sfc_main$1, {
        class: normalizeClass([
          "card--product",
          "product-card",
          { "product-card--is-loading": _ctx.isLoading },
          { "has-previous-price-text": props?.product?.previousPriceText }
        ]),
        "has-link-behavior": _ctx.link ? true : void 0,
        "card-data-attributes": _ctx.cardDataAttributes
      }, {
        header: withCtx(() => [
          createElementVNode("div", _hoisted_1, [
            props.product.media && _ctx.isLoading ? (openBlock(), createBlock(_sfc_main$2, {
              key: 0,
              class: "product-card__loading-media"
            })) : (openBlock(), createBlock(_sfc_main$4, {
              key: 1,
              media: props.product.media,
              cols: [3, 3, 6],
              class: normalizeClass({ "has-spacing": !_ctx.isFullsizeImage }),
              lazyload: true
            }, null, 8, ["media", "class"])),
            createElementVNode("h2", _hoisted_2, [
              createVNode(_sfc_main$5, mergeProps(_ctx.link, {
                "is-renderless": true,
                class: _ctx.link ? "product-card__headline-link" : void 0
              }), {
                default: withCtx(() => [
                  createElementVNode("span", _hoisted_3, [
                    props.product.name && _ctx.isLoading ? (openBlock(), createBlock(_sfc_main$2, {
                      key: 0,
                      class: "product-card__loading-headline"
                    })) : (openBlock(), createElementBlock("span", {
                      key: 1,
                      class: "product-card__headline-part",
                      innerHTML: props.product.name
                    }, null, 8, _hoisted_4)),
                    props.product.variantName && _ctx.isLoading ? (openBlock(), createBlock(_sfc_main$2, {
                      key: 2,
                      class: "product-card__loading-headline"
                    })) : (openBlock(), createElementBlock("span", {
                      key: 3,
                      class: "product-card__headline-part",
                      innerHTML: props.product.variantName
                    }, null, 8, _hoisted_5))
                  ])
                ]),
                _: 1
              }, 16, ["class"])
            ]),
            props.badgeText && _ctx.isLoading ? (openBlock(), createBlock(_sfc_main$2, {
              key: 2,
              class: "product-card__loading-badge"
            })) : props.badgeText ? (openBlock(), createBlock(_sfc_main$6, {
              key: 3,
              "badge-style": props.badgeStyle ? props.badgeStyle : void 0,
              "is-rounded": true,
              "icon-name": "pricetag-alt",
              size: "small",
              "has-shine-animation": true
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(props.badgeText), 1)
              ]),
              _: 1
            }, 8, ["badge-style"])) : createCommentVNode("", true)
          ])
        ]),
        default: withCtx(() => [
          props.product.description && _ctx.isLoading ? (openBlock(), createElementBlock("p", _hoisted_6, [
            (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.loadingLines, (index) => {
              return openBlock(), createBlock(_sfc_main$2, {
                class: "product-card__loading-content",
                key: index
              });
            }), 128))
          ])) : props.product.description && props.product.description !== " " ? (openBlock(), createElementBlock("p", {
            key: 1,
            innerHTML: props.product.description
          }, null, 8, _hoisted_7)) : createCommentVNode("", true),
          props.showAttributes && Array.isArray(props.product.attributes) && props.product.attributes.length > 0 ? (openBlock(), createBlock(_sfc_main$3, {
            key: 2,
            attributes: props.product.attributes,
            "is-loading": _ctx.isLoading,
            "loading-lines": _ctx.attributesLoadingLines
          }, null, 8, ["attributes", "is-loading", "loading-lines"])) : createCommentVNode("", true),
          renderSlot(_ctx.$slots, "default")
        ]),
        footer: withCtx(() => [
          props.product.pricePrefix || props.product.priceText ? (openBlock(), createElementBlock("div", _hoisted_8, [
            props.product.pricePrefix ? (openBlock(), createElementBlock("small", _hoisted_9, [
              createElementVNode("span", _hoisted_10, toDisplayString(props.product.pricePrefix), 1),
              props.product.pricePrefixAttentionText ? (openBlock(), createElementBlock("span", _hoisted_11, toDisplayString(props.product.pricePrefixAttentionText), 1)) : createCommentVNode("", true)
            ])) : createCommentVNode("", true),
            createElementVNode("div", _hoisted_12, [
              props.product.priceText ? (openBlock(), createElementBlock("strong", _hoisted_13, toDisplayString(props.product.priceText), 1)) : createCommentVNode("", true),
              props.product.previousPriceText ? (openBlock(), createElementBlock("span", _hoisted_14, toDisplayString(props.product.previousPriceText), 1)) : createCommentVNode("", true)
            ])
          ])) : createCommentVNode("", true),
          renderSlot(_ctx.$slots, "footer")
        ]),
        _: 3
      }, 8, ["class", "has-link-behavior", "card-data-attributes"]);
    };
  }
});

export { _sfc_main as default };
